<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Btn } from '@jennifersoft/vue-components-v2';

const emit = defineEmits<{
    (e: 'login'): void;
}>();

const { t } = useI18n();
</script>

<template>
    <div class="succeeded">
        <div class="title">{{ t('M0640') }}</div>
        <div class="description">{{ t('M0107') }}</div>
        <div class="footer">
            <Btn
                :text="t('ui.button.login')"
                size="large"
                @click="emit('login')"
            />
        </div>
    </div>
</template>

<style lang="scss">
.succeeded {
    display: flex;
    flex-direction: column;

    .title {
        font-size: 32px;
        font-weight: bold;
        color: var(--gray-900, #222229);
        width: 280px;
        white-space: pre-line;
    }
    .description {
        margin: 40px 0 56px;
        font-size: 16px;
        line-height: 1.5;
        color: var(--gray-600, #75757c);
    }

    .footer {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
